import { IListingData } from '@models/listing';

export function mapToModelsListingData(
  raw: any[],
  brandLovs: Record<string, string>
): IListingData<any> {
  const list: Record<string, any> = {};

  raw.forEach((item, index) => {
    list[index] = {
      Brand:
        brandLovs[item?.Insurance_Brands] || item?.Insurance_Brands || 'N/A',
      Code: item.Code,
      ModelCode: item.ModelCode,
      Title: item.Title,
      _original: item,
    };
  });

  return {
    pagedItems: list,
    pageSize: 10,
    pageNumber: 0,
    totalCount: raw.length,
  };
}
